import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface NotificationQueryOptions {
  limit?: number;
  page?: number;
  isRead?: boolean;
}

export interface NotificationQueryResult {
  results: any[];
  page: number;
  limit: number;
  totalPages: number;
  totalResults: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private apiUrl = `${environment.apiUrl}/notifications`;

  constructor(private http: HttpClient) { }

  getNotifications(options: NotificationQueryOptions = {}): Observable<NotificationQueryResult> {
    let params = new HttpParams();

    if (options.page) {
      params = params.set('page', options.page.toString());
    }

    if (options.limit) {
      params = params.set('limit', options.limit.toString());
    }

    if (options.isRead !== undefined) {
      params = params.set('isRead', options.isRead.toString());
    }

    return this.http.get<NotificationQueryResult>(this.apiUrl, { params });
  }

  markAsRead(notificationId: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${notificationId}/read`, {});
  }

  markAllAsRead(): Observable<any> {
    return this.http.patch(`${this.apiUrl}/mark-all-read`, {});
  }

  getUnreadCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.apiUrl}/unread-count`);
  }
}